let key = {};
let IPFS_IMG = "https://theimpactcollective.infura-ipfs.io/ipfs/";
var networkVersion = "";
var BNBProvider = "";
let Back_Url = "";
let decimalValues = 1000000000000000000;
var FRONT_URL = "";
var ImG = "";
var EnvName = "production";
var Front_market_Url = '';
var AdminAddress = '0x8f4ad1aE5AB57b2DA6DCd0Be762048bB4692C0Ce';

if (EnvName === "local") {
  Back_Url = "http://localhost:3331/v1/admin";
  Front_market_Url = "http://localhost:3000/goldenideaadmin";
  var image_url = "hhttp://localhost:3331/token";
  ImG = "http://localhost:3331";
  var tradeAddress = "0x3bE52bd3A97ac6Ba20F1482e58d9694B3E15Fb05";
  var singleAddress = "0x9A9EBc3A48D9ddc54A2D6A3599642aBA4363E7e1";
  var multipeAddress = "0x4958A36d8d71abd35D5434EF78023B3284D93e63";
  var Bulkmint = '0xf1B805e31d151F4f3D3f177D8C2FDB3ff3AeE0Ed'.toLowerCase()
  var networkVersion = "97";
  var chainId = "0x97";
  BNBProvider = "https://data-seed-prebsc-1-s1.binance.org:8545/";
  var Back_Url_Token = "http://localhost:3331/v1";
  AdminAddress = "0x8f4ad1aE5AB57b2DA6DCd0Be762048bB4692C0Ce";
}

// if (EnvName === "stage") {
//   Back_Url = "https://apistaging.theimpactcollective.com/admin";
//   Front_market_Url = "http://localhost:3000";
//   var image_url = "https://apistaging.theimpactcollective.com/token";
//   ImG = "https://apistaging.theimpactcollective.com";
//   var tradeAddress = "0x16D9f2EA5Ab7c93Ef3aB2c7E983CfC12FB03b91c";
//   var singleAddress = "0x26a40070a000f717A32d3e6AAe9A8f26552fB662";
//   var multipeAddress = "0xae4d5a74432e6e0702bc61d7e537161ff5d740ac";
//   var networkVersion = "97";
//   var chainId = "0x61";
//   BNBProvider = "https://data-seed-prebsc-1-s1.binance.org:8545/";
//   var Back_Url_Token = "https://apistaging.theimpactcollective.com/v1";
// }

if (EnvName === "demo") {
  Back_Url = "http://192.53.121.26:7006/v1/admin";
  Front_market_Url = "http://nftdemo.bimaticz.com/goldenideaadmin";
  var image_url = "http://192.53.121.26:7006/token";
  ImG = "http://192.53.121.26:7006";
  var tradeAddress = "0x3bE52bd3A97ac6Ba20F1482e58d9694B3E15Fb05";
  var singleAddress = "0x9A9EBc3A48D9ddc54A2D6A3599642aBA4363E7e1";
  var multipeAddress = "0x4958A36d8d71abd35D5434EF78023B3284D93e63";
  var Bulkmint = '0xf1B805e31d151F4f3D3f177D8C2FDB3ff3AeE0Ed'.toLowerCase()
  var networkVersion = "97";
  var chainId = "0x97";
  BNBProvider = "https://data-seed-prebsc-1-s1.binance.org:8545/";
  var Back_Url_Token = "http://192.53.121.26:7006/v1";
  AdminAddress = "0x8f4ad1aE5AB57b2DA6DCd0Be762048bB4692C0Ce";
}

if (EnvName === "production") {
  FRONT_URL = 'https://goldenideanft.com';
  Front_market_Url = 'https://goldenideanft.com';
  Back_Url = 'https://api.goldenideanft.com/v1/admin';
  var image_url = "https://api.ditmax.market/token";
  ImG = 'https://api.goldenideanft.com';
  var tradeAddress = "0x9a0f37c162AEAa884141A472C208A813242174b4";
  var singleAddress = "0xA6Af093FA40ca4CEF36c9F8e9cBF95eE8b37fDFF";
  var multipeAddress = "0xE70B458e1b9a1A7887957A5Ae1A139DC98A31B0d";
  var Bulkmint = '0xb3a539e1bF63217EAf5791398B4740cbC7e1f1c0'.toLowerCase()
  var networkVersion = "1";
  var chainId = "0x1";
  BNBProvider = "https://mainnet.infura.io/v3/be5bdb23c61c4b92b174cb569e57f7b2";
  var Back_Url_Token = "https://api.goldenideanft.com/v1/";
  AdminAddress = "0x8f4ad1aE5AB57b2DA6DCd0Be762048bB4692C0Ce";

}

key = {
  AdminAPI: `${Back_Url}`,
  Back_Url: `${Back_Url_Token}`,
  chainId: chainId,
  BNBProvider: BNBProvider,
  tradeAddress: tradeAddress,
  singleAddress: singleAddress,
  multipeAddress: multipeAddress,
  ImG: ImG,
  IPFS_IMG: IPFS_IMG,
  AdminAddress: AdminAddress,
  noimg: require("../assets/images/No_image.webp"),
  FRONT_URL: FRONT_URL,
  Front_market_Url: Front_market_Url,
  networkVersion: networkVersion,
  Bulkmint: Bulkmint
};

export default key;
